import { render } from "./VisitorEmergencyContactTable.vue?vue&type=template&id=56606ccf"
import script from "./VisitorEmergencyContactTable.vue?vue&type=script&lang=js"
export * from "./VisitorEmergencyContactTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__